import React from 'react';
import { Row, Col, Spin, Statistic, Typography } from 'antd';

const TotalizadorVentasGnvDetalle = ({ loading, totalizadores }: any) => {

  return (
    <Row style={{ width: '100%' }} justify="space-around" align="middle" gutter={16}>
      <Col span={6} style={{ textAlign: 'center' }}>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <Typography.Text>Total cantidad</Typography.Text>
            <Spin />
          </div>
        ) : (
          <Statistic suffix="LT" title="Total cantidad" value={totalizadores.cantidad} precision={2} />
        )}
      </Col>
      <Col span={6} style={{ textAlign: 'center' }}>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <Typography.Text>Total venta bruta</Typography.Text>
            <Spin />
          </div>
        ) : (
          <Statistic prefix="$" title="Total venta bruta" value={totalizadores.valor_venta_bruta} precision={2} />
        )}
      </Col>
      <Col span={6} style={{ textAlign: 'center' }}>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <Typography.Text>Total recaudado</Typography.Text>
            <Spin />
          </div>
        ) : (
          <Statistic prefix="$" title="Total recaudado" value={totalizadores.valor_venta_recaudo} precision={2} />
        )}
      </Col>
      <Col span={6} style={{ textAlign: 'center' }}>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <Typography.Text>Total ventas</Typography.Text>
            <Spin />
          </div>
        ) : (
          <Statistic prefix="$" title="Total ventas" value={totalizadores.valor_venta_total} precision={2} />
        )}
      </Col>

    </Row>
  );
};

export default TotalizadorVentasGnvDetalle;
